import { Box, styled } from '@mui/material';
import { useRef, useState } from 'react';
import { getMedia } from 'utils/getImage';
import SvgIconStyle from './SvgIconStyle';

export const Uploader = ({ media, setMedia = () => undefined, accept = 'image/*', width }) => {
  const fileRef = useRef();
  const [blob, setBlob] = useState(null);
  const onUpload = (file) => {
    if (!file) return;
    const imageBlob = URL.createObjectURL(file);
    setBlob(imageBlob);
    setMedia(file);
  };
  return (
    <Root width={width} onClick={() => fileRef.current.click()}>
      {blob || media ? (
        <Image src={blob || getMedia(media)} alt="" width={width} />
      ) : (
        <SvgIconStyle src="/icons/add-circle.svg" sx={{ width: '20px', height: '20px' }} />
      )}
      <input type="file" accept={accept} ref={fileRef} hidden onChange={(e) => onUpload(e.target.files[0])} />
    </Root>
  );
};
const Image = styled('img')(({ width }) => ({
  width: '100%',
  maxWidth: width,
  height: 'auto',
}));
const Root = styled(Box)(({ width }) => ({
  width,
  minWidth: '160px',
  height: '150px',
  border: '1px solid #ddd',
  borderRadius: '20px',
  boxShadow: '0px 12px 22px rgba(0, 0, 0, 0.09)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  overflow: 'hidden',
}));
